import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ItinerariesList } from './components/ItinerariesList';
import { ItineraryForm } from './components/ItineraryForm';
import SingleItinerary from './single';

const ItinerariesRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<ItinerariesList />} />
      <Route path='create' element={<ItineraryForm />} />
      <Route path='edit/:id' element={<ItineraryForm />} />
      <Route path=':id' element={<SingleItinerary />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default ItinerariesRoutes;



